var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { Tooltip } from "react-bootstrap";
import LabelValue from "../LabelValue";
export var StyledTooltip = styled(Tooltip)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .tooltip-inner {\n    max-width: 300px;\n    word-wrap: break-word;\n  }\n"], ["\n  .tooltip-inner {\n    max-width: 300px;\n    word-wrap: break-word;\n  }\n"])));
export var Pin = styled(LabelValue)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-bottom: 3px;\n"], ["\n  margin-bottom: 3px;\n"])));
var templateObject_1, templateObject_2;
